module.exports = __webpack_public_path__ + "static/media/insta2.7a6fe037.jpg";